import React, { useContext, useEffect, useState } from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useGetMyToken, useGetProfile } from '../Myprofile/api';
import { useGetDashBoard, useGetPreSales, useGetSales } from './api';
import { copyToClipboard } from '../../lib/copytoClipboard';
import { Check, Copy } from 'lucide-react';
import { useToast } from '../../hook/usetoast';
import { useNavigate } from "react-router-dom";
import { useChooseCurrency, useGetCurrency } from '../BuyToken/api/buyTokenApi';
import TimerContext from '../TimerContext/Timercontext';
import { useTranslation } from 'react-i18next';
import Loader from '../../Loader/buttonLoad';
import { TransferHistorySkeleton } from '../../Loader/skeleton'
const Dashboard = (props) => {

    const { days, hours, minutes, seconds, visible } = useContext(TimerContext)
    const navigate = useNavigate()
    const { data: getProfile, isLoading } = useGetProfile()
    const { data: getDashboard, isLoading: dashLoader } = useGetDashBoard()
    console.log("🦁 ~ Dashboard ~ getDashboard:", getDashboard)
    const { data: getSalesProgress, isLoading: salesLoader } = useGetSales()
    const { data: getPreSales, isLoading: preSaleLoader } = useGetPreSales()
    const presaleActive = getPreSales?.data?.isActive == 'active'

    const {  isFetching } = useGetMyToken()


    const [refdone, setRefdone] = useState()
    const toast = useToast()
    const { t } = useTranslation()

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            toast.success('copied', {
                className: "text-white"
            })
        }).catch(err => {
            console.error('Failed to copy: ', err);
        });
    };

    const copyRef = async (data) => {
        await copyToClipboard(`https://kkog.io/register/${getProfile?.data?.referralCode}`)
        toast.success("Referral copied")
        setTimeout(() => {
            setRefdone()
        }, 800)
    }

    const copyRefferral = async (data) => {
        await copyToClipboard(getProfile?.data?.referralCode)
        toast.success("Referral copied")
    }


    const { data: getCurrency, isLoading: currLoader } = useGetCurrency();
    const [chooseCurrency, setChooseCurrency] = useState(getCurrency?.data?.currency_details?.currency_symbol)

    const { data: listCurrency, isLoading: listLoader } = useChooseCurrency({ currencySymbol: chooseCurrency?.currency_details?.currency_symbol })



    useEffect(() => {
        if (getCurrency?.data?.length > 0 && !chooseCurrency) {
            const defaultCurrency = getCurrency.data.find(currency => currency.currency_details?.currency_code === 'NGN');

            if (defaultCurrency) {
                setChooseCurrency(defaultCurrency);
            } else {
                setChooseCurrency(getCurrency.data[0]);
            }
        }
    }, [getCurrency?.data]);
    const handleChooseCurrency = (currency) => {
        setChooseCurrency(currency)
    }


    //--------- Post Sale Calculation --------//

    const postPurchased = getSalesProgress?.data?.totalPurchased;
    const postSupply = getSalesProgress?.data?.totalSupply

    const availablePostTokens = postSupply - postPurchased

    const salePercentage = postSupply > 0 && (availablePostTokens / postSupply) * 100


    //-----Pre Sale Calculation --------//

    const prePurchased = getPreSales?.data?.totalPurchased;
    const preSupply = getPreSales?.data?.totalPreSupply

    const availablePreTokens = preSupply - prePurchased

    const presalePercentage = preSupply > 0 && (availablePreTokens / preSupply) * 100


    const renderContent = () => {
        if (dashLoader) {
            return <TransferHistorySkeleton />;
        }

        if (getDashboard?.transactions?.length === 0) {
            return (
                <tr>
                    <td colSpan={8} style={{ textAlign: 'center' }}>{t('No data found')}</td>
                </tr>
            );
        }

        return (getDashboard?.transactions)?.slice(0, 5).map((v) => (
            <tr key={v.trx_id}>
                <td>
                    {v.trx_id ? (
                        <div className='d-flex'>
                            {v.trx_id ? `${v.trx_id.substring(0, 8)}..${v.trx_id.substring(v.trx_id.length - 8)}` : '-'}
                            <button
                                className="cursor-pointer ml-2 ms-2"
                                style={{ color: "#dfb9df", all: "unset", cursor: "pointer" }}
                                onClick={() => handleCopy(v.trx_id)} aria-label="Copy transaction hash"
                            >
                                <Copy />
                            </button>
                        </div>
                    ) : '-'}
                </td>
                <td>{v.fromAmount} {v.fromCurrency}</td>
                <td>{parseFloat(v.toAmount).toFixed(8)}</td>
                <td>{parseFloat(v.bonusAmount).toFixed(8)}</td>
                {/* <td>{v.paymentType === "crypto" ? v.totalAmount : parseFloat(v.totalAmount).toFixed(2)} KKOG</td> */}
                <td>{parseFloat(v.totalAmount).toFixed(8)} KKOG</td>
                <td>{v.paymentType}</td>
                <td>{new Date(v.createdAt).toLocaleString()}</td>
                <td className='text-right'>
                    {v.status ? <span className='Grn'>{t('Purchase')}</span> : <span className='Grn'>{t('Pending')}</span>}
                </td>
            </tr>
        ));
    };

    const renderHistoryContent = () => {
        if (dashLoader) {
            return <TransferHistorySkeleton />;
        }

        if (getDashboard?.History?.length === 0) {
            return (
                <tr>
                    <td colSpan={8} style={{ textAlign: 'center' }}>{t('No data found')}</td>
                </tr>
            );
        }

        return (getDashboard?.History)?.slice(0, 5).map((v) => (
            <tr key={v}>
                <td>{new Date(v.date).toLocaleString()}</td>
                <td>{v.browser_name}</td>
                <td>{v.os_name}</td>
                <td>{v.ip_address}</td>
            </tr>
        ));
    };

    const renderReferralInfo = () => {
        // Check if loading or if referral code exists
        if (isLoading || !getProfile?.data?.referralCode) {
            return null;
        }

        const referralLink = `https://kkog.io/register/${getProfile.data.referralCode}`;
        const isCodeCopied = refdone === getProfile.data.referralCode;

        return (
            <>
                <div className='DshbrdRflk'>
                    <label>{t('Referral Link')}</label>
                    <div className='CpyLkDv'>
                        <input
                            className='form-control'
                            type='text'
                            readOnly
                            value={referralLink}
                        />
                        <button className="btn" onClick={() => copyRef(getProfile.data.referralCode)}>
                            {isCodeCopied ? (
                                <Check size={20} />
                            ) : (
                                <img
                                    src={require("../../assets/images/copy.svg").default}
                                    alt="copy"
                                    className='CpyLkDvIg'
                                />
                            )}
                        </button>
                    </div>
                </div>

                <div className='DshbrdRflCd'>
                    <label>{t('Referral Code')}</label>
                    <h3>
                        {getProfile.data.referralCode}
                        <button className="btn" onClick={() => copyRefferral(getProfile.data.referralCode)}>
                            {isCodeCopied ? (
                                <Check size={20} />
                            ) : (
                                <img
                                    src={require("../../assets/images/copy.svg").default}
                                    alt="copy"
                                    className='CpyLkDvIg'
                                />
                            )}
                        </button>
                    </h3>
                </div>
            </>
        );
    };


const exchangeRateText = () => {
   

    if (!chooseCurrency?.kkogprice || !chooseCurrency?.currency_details) {
  return '0';
}


    console.log("🦁 ~ exchangeRateText ~ chooseCurrency?.kkogprice:", chooseCurrency?.kkogprice)
  


        return typeof chooseCurrency?.kkogprice === 'number' && chooseCurrency?.kkogprice !== 0
  ? `${chooseCurrency.kkogprice.toFixed(6)} ${chooseCurrency?.currency_details?.currency_symbol ?? ''}`
  : '0';

};


const displayWalletAddress = () => {
    if (isLoading) return "-";
    const walletAddress = getProfile?.data?.walletAddress;
    if (walletAddress) {
        return `${walletAddress.slice(0, 10)}...${walletAddress.slice(-7)}`;
    }
    return "-";
};          


    return (
        <div className="DshbrdPg">
            {(isLoading || isFetching || dashLoader) && <Loader />}
            <div className="DshbrdDv">
                <div className="row DshbrdCnBl CustRw">
                    <div className="col-lg-4 col-md-6 CustPad">
                        <div className="DshbrdCnBlDts">
                            <div className="DshbrdCnBlDtsTp">
                                <img src={require('../../assets/images/kkogcoin.png')} alt="" className='mr-2' />
                                <div>
                                    <h6>{t('Coin Balance')}</h6>
                                    <h4>{isLoading ? '' : parseFloat(getProfile?.balance?.currencyBalance).toFixed(8)} <span>KKOG</span></h4>
                                </div>
                            </div>
                            <div className='DshbrdCnBlDtsCntr'>
                                <label>{t('You Contribution in')}</label>
                                {currLoader ? '' : getCurrency?.data?.length > 0 && (
                                    <div className='DshbrdCnBlDtsCntrFlx'>
                                        <UncontrolledDropdown className="HdrCntryDD">
                                            <DropdownToggle className="HdrCntryDDBg">
                                                <img src={chooseCurrency?.currency_details?.image} alt="" />
                                                <span className='mx-2'>{chooseCurrency?.currency_details?.currency_code}</span>
                                                <img src={require('../../assets/images/down-arrow-white.png')} alt="" className="ArwDwn" />
                                            </DropdownToggle>
                                            <DropdownMenu className="dropdown-menu-right">
                                                {getCurrency?.data?.map((currency) => (
                                                    <DropdownItem key={currency} onClick={() => handleChooseCurrency(currency)}>
                                                        <img src={currency?.currency_details?.image} alt="" />
                                                        <span className='ml-2'>{currency?.currency_details?.currency_code}</span>
                                                    </DropdownItem>
                                                ))}
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                        <h4>{listLoader ? '' : listCurrency?.totalAmount && parseFloat(listCurrency?.totalAmount).toFixed(2)} <span>{chooseCurrency?.currency_details?.currency_symbol}</span></h4>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 CustPad">
                        <div className='DshbrdByTkn'>
                            <div className='DshbrdByTknTp'>
                                <h4>KKOG {t('Coin')}</h4>
                                <h5>{t('Buy Token')}</h5>
                            </div>
                            <div className='DshbrdByTknDts'>

   


<h3>
  1 KKOG = {exchangeRateText()}
</h3>
<h3>
  1 KKOG = 
  {dashLoader ? 
    '0 USD' : 
   
    getDashboard?.kkogusdprice[0]?.usd_price +" USD"
  }
</h3>

                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 CustPad">
                        <div className='DshbrdPrfl'>
                            <div className='DshbrdPrflTp'>
                                <h4>{t('Welcome')} <span>{isLoading ? '' : getProfile?.data?.userName}</span></h4>
                            </div>
                            <div className='DshbrdPrflVrfy'>
                                <label>{t('Your Account Status')}</label>
                                <h5>{t('Email Verified')}<img src={require('../../assets/images/tick-circle.svg').default} alt='' /></h5>
                                <div className='mt-2'>
                                    <label>{t('Receiving Wallet')}</label>
                                 <p>{displayWalletAddress()}</p>



                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row DshbrdTrnsTknSl CustRw'>
                    <div className='col-lg-8 CustPad'>
                        <div className='DshbrdTrnsTknSlDts'>
                            <div className='DshbrdTrnsTknSlTp'>
                                <h4>{t('Transaction')}</h4>
                                <button style={{ all: "unset", cursor: "pointer" }} onClick={() => navigate('/transaction')}><h5>{t('View All')}</h5></button>
                            </div>
                            <div className='table-responsive px-3'>
                                <table className='table' aria-hidden='true'>
                                    <thead>
                                        <th>{t('Tranx No')}</th>
                                        <th>{t('Currency')}</th>
                                        <th>{t('To Amount')}</th>
                                        <th>{t('Bonus Amount')}</th>
                                        <th>{t('Amount')}</th>
                                        <th>{t('Payment Type')}</th>
                                        <th>{t('Date & Time')}</th>
                                        <th className='text-right'>{t('Type')}</th>
                                    </thead>
                                    <tbody>
                                        {
                                            renderContent()
                                        }


                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4 CustPad'>
                        {presaleActive ?
                            <div className='DshbrdTknslPrgs'>
                                <div className='DshbrdTknslPrgsTp'>
                                    <h4>{t('Token Sales Progress')}</h4>
                                </div>

                                <div className='DshbrdTknAmt'>
                                    <div className='Ldv'>
                                        <h6>{t('Raised Amount')}</h6>
                                        <p>{preSaleLoader ? '' : (getPreSales?.data?.totalPurchased || 0)} KKOG</p>
                                    </div>
                                    <div className='Rdv'>
                                        <h6>{t('Total Token')}</h6>
                                        <p>{preSaleLoader ? '' : getPreSales?.data?.totalPreSupply} KKOG</p>
                                    </div>
                                </div>

                                <div className='DshbrdTknPrgsDv'>
                                    <div className="progress">
                                        <div className="progress-bar" style={{ width: `${presalePercentage}%` }} />
                                    </div>
                                </div>

                                {visible ?
                                    <div className='DshbrdSlEdDv'>
                                        <label>{t('Sales End in')}</label>
                                        <div className='BnrTmr'>
                                            <div className="BnrTmrDv">
                                                <div className='Ldv'>
                                                    <h4>{days}</h4>
                                                    <h6>{t('Days')}</h6>
                                                </div>
                                                <div className='Rdv'>:</div>
                                                <div className='Ldv'>
                                                    <h4>{hours}</h4>
                                                    <h6>{t('Hours')}</h6>
                                                </div>
                                                <div className='Rdv'>:</div>
                                                <div className='Ldv'>
                                                    <h4>{minutes}</h4>
                                                    <h6>{t('Minutes')}</h6>
                                                </div>
                                                <div className='Rdv'>:</div>
                                                <div className='Ldv'>
                                                    <h4>{seconds}</h4>
                                                    <h6>{t('Seconds')}</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : ""}
                            </div>

                            : <div className='DshbrdTknslPrgs'>
                                <div className='DshbrdTknslPrgsTp'>
                                    <h4>{t('Token Sales Progress')}</h4>
                                </div>

                                <div className='DshbrdTknAmt'>
                                    <div className='Ldv'>
                                        <h6>{t('Raised Amount')}</h6>
                                        <p>{salesLoader ? '' : (getSalesProgress?.data?.totalPurchased || 0)} KKOG</p>
                                    </div>
                                    <div className='Rdv'>
                                        <h6>{t('Total Token')}</h6>
                                        <p>{salesLoader ? '' : getSalesProgress?.data?.totalSupply} KKOG</p>
                                    </div>
                                </div>

                                <div className='DshbrdTknPrgsDv'>
                                    <div className="progress">
                                        <div className="progress-bar" style={{ width: `${salePercentage}%` }} />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className='row DshbrdHistRfr CustRw'>
                    <div className='col-lg-8 CustPad'>
                        <div className='DshbrdHistDts'>
                            <div className='DshbrdHistDtsTp'>
                                <h4>{t('Login History')}</h4>
                            </div>
                            <div className='table-responsive px-3'>
                                <table className='table' aria-hidden='true'>
                                    <thead>
                                        <th>{t('Date & Time')}</th>
                                        <th>{t('Browser')}</th>
                                        <th>{t('OS')}</th>
                                        <th>{t('Ip Address')}</th>
                                    </thead>
                                    <tbody>
                                        {
                                            renderHistoryContent()
                                        }


                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4 CustPad'>
                        <div className='DshbrdRfrDts'>
                            <div className='DshbrdRfrDtsTp'>
                                <h4>{t('Refer Your Friends')}</h4>
                            </div>
                            <div className='DshbrdRfrCnt'>
                                <div className='Ldv'>
                                    <h5>{t('Total Referral')}</h5>
                                    <h3>{dashLoader ? '' : getDashboard?.Count}</h3>
                                </div>
                                <div className='Ldv'>
                                    <h5>{t('Referral Bonus')}</h5>
                                    <h3>{dashLoader ? '' : getDashboard?.Amount} KKOG</h3>
                                </div>
                            </div>
                            {
                                renderReferralInfo()

                            }


                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Dashboard;
